module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-log"
  }, [_c('b', [_vm._v("User:  ")]), (_vm.item.user_id) ? _c('b', [_vm._v(_vm._s(_vm.item.user_id) + " [" + _vm._s(_vm.item.user_type) + "] @ " + _vm._s(_vm.item.ip_address))]) : _c('b', [_vm._v(_vm._s(_vm.item.ip_address))]), _c('hr'), _c('b', [_vm._v("Entity snapshot:")]), _c('pre', [_vm._v(_vm._s(_vm.item.snapshot))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1172811d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Log.vue
// module id = 2281
// module chunks = 1